const IdentificationType = {
  DNI: 'DNI',
  CUIL: 'CUIL',
  CUIT: 'CUIT',
  LE: 'LE',
  LC: 'LC',
};

export default IdentificationType;
